import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getDeviceList } from '../../services/api/deviceApi';
import DeviceListTable from './DeviceListTable';
import DeviceNameUpdate from './DeviceNameUpdate';
import '../../pages/Admin/Admin.styles.css';

const UpdateDeviceName = () => {
    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch devices on component mount
    useEffect(() => {
        fetchDevices();
    }, []);

    const fetchDevices = async () => {
        setLoading(true);
        try {
            const deviceList = await getDeviceList();
            setDevices(deviceList);
        } catch (error) {
            console.error('Failed to fetch devices:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* Toast Container for notifications */}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            {/* Device Name Update Section */}
            <section className="admin-section">
                <DeviceNameUpdate onUpdateSuccess={fetchDevices} />
            </section>

            {/* Device List Section */}
            <section className="admin-section">
                <div className="admin-section-header">
                    <h2 className="admin-section-title">Device List</h2>
                    <button
                        className="admin-refresh-btn"
                        onClick={fetchDevices}
                        disabled={loading}
                    >
                        <span className="material-icons-outlined">refresh</span>
                        Refresh
                    </button>
                </div>
                <DeviceListTable devices={devices} loading={loading} />
            </section>
        </>
    );
};

export default UpdateDeviceName;
